import React from 'react';
import PropTypes from 'prop-types';

export default class EnvironmentManager extends React.PureComponent {

  props: {
    reset: () => void,
    children: React.Element,
  };

  static childContextTypes = {
    resetEnvironment: PropTypes.func,
  };

  getChildContext() {
    return {
      resetEnvironment: this.props.reset,
    };
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ../src/client/EnvironmentManager.js